import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='account' />
}

const skin = era.skin('routes/settings/account-settings')

AccountSettingsSubPage.displayName = 'AccountSettingsSubPage'
export function AccountSettingsSubPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='accountSettingsSubPageSkin' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
